export const CLIENT_WIDTH_OFFSET = 15; // pixels
export const NO_SCROLL_CLASS = 'no-scroll';
